import { FunnelStage } from "./types";
import styles from "./style.module.scss";

interface FunnelColumnsProps {
  stages: FunnelStage[];
  format?: (value: number) => string;
}

/** Column view: proportional bars with the drop from the previous stage. */
function FunnelColumns({ stages, format }: FunnelColumnsProps) {
  const toText = format ?? ((value: number) => value.toLocaleString("en-US"));

  return (
    <div className={styles.cols}>
      <div className={styles.colChart}>
        {stages.map((stage, index) => (
          <div key={stage.key} className={styles.col}>
            <div className={styles.colValue}>{toText(stage.value)}</div>
            <div
              className={styles.colBar}
              // Floor the height so a tiny final stage stays readable.
              style={{
                height: `${Math.max(14, stage.share)}%`,
                background: `linear-gradient(180deg, ${stage.color}, ${
                  stages[Math.min(index + 1, stages.length - 1)].color
                })`,
              }}
            >
              {`${Math.round(stage.share)}%`}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.colLabels}>
        {stages.map((stage) => (
          <div key={stage.key} className={styles.colLabel}>
            <div className={styles.colName}>{stage.label}</div>
            <div
              className={stage.drop === undefined ? styles.colBase : styles.colDrop}
            >
              {stage.drop === undefined
                ? "baseline"
                : `−${Math.round(stage.drop)}% drop`}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FunnelColumns;
